var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFackbookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7563 12.1364C23.7563 5.6537 18.5319 0.398438 12.0872 0.398438C5.64244 0.398438 0.417969 5.6537 0.417969 12.1364C0.417969 17.9952 4.68522 22.8512 10.2638 23.7318V15.5294H7.30097V12.1364H10.2638V9.55038C10.2638 6.60856 12.006 4.98358 14.6715 4.98358C15.9482 4.98358 17.2836 5.21284 17.2836 5.21284V8.10148H15.8121C14.3625 8.10148 13.9105 9.00629 13.9105 9.93455V12.1364H17.1468L16.6295 15.5294H13.9105V23.7318C19.4891 22.8512 23.7563 17.9952 23.7563 12.1364Z",
    fill: "#1778F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFackbookicon);
export default __webpack_public_path__ + "static/media/fackbookicon.2a7fc46cd2c9f08fbe71a16824f7a80e.svg";
export { ForwardRef as ReactComponent };